import { render, staticRenderFns } from "./ReClientContacts.vue?vue&type=template&id=8c1871c2"
import script from "./ReClientContacts.vue?vue&type=script&lang=js"
export * from "./ReClientContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports